import { useTransition, animated } from 'react-spring';
import { ProgressNotifierItem } from './ProgressNotifierItem';
import { ProgressNotifierProps } from './ProgressNotifier.types';

export const ProgressNotifier = ({ items, onRemove }: ProgressNotifierProps) => {
  const transition = useTransition(items, {
    from: { y: 0, x: 0 },
    enter: { y: -100, x: 0 },
    leave: { y: -100, x: 400 },
  });
  return (
    <div
      className={[
        'fixed right-8 top-12 flex w-80 flex-col-reverse gap-4 bg-transparent p-4',
        'pointer-events-none z-[99999999] h-[80vh] overflow-y-auto overflow-x-hidden',
        'no-scrollbar',
      ].join(' ')}
    >
      {transition(
        (style, item) =>
          item && (
            <animated.div style={style}>
              <ProgressNotifierItem data={item} onRemove={onRemove} />
            </animated.div>
          ),
      )}
    </div>
  );
};
